import './style.css'
import { renderSettings } from './views/settings.js'
import { renderLibrary } from './views/library.js'
import { renderPlayer } from './views/player.js'
import { renderReview } from './views/review.js'
import { renderWords } from './views/words.js'
import { bgSync } from './lib/sync.js'
import { autoUploadAll } from './lib/drivepush.js'
import { icon } from './lib/icons.js'
import { t } from './lib/i18n.js'
import {
  isStandalone,
  isIOS,
  canPromptInstall,
  promptInstall,
  requestPersist,
} from './lib/pwa.js'

const INSTALL_DISMISS_KEY = 'immerso-install-dismissed'

// 未インストール時のみ「ホーム画面に追加」を促すバナーを出す（×で消せる）。
function buildInstallBanner() {
  if (isStandalone() || localStorage.getItem(INSTALL_DISMISS_KEY)) return null
  if (!canPromptInstall() && !isIOS()) return null

  const el = document.createElement('div')
  el.className = 'install-banner'
  if (canPromptInstall()) {
    el.innerHTML = `<div>${t('install.benefit')}</div>
      <div class="ib-actions"><button class="mini" id="ib-install">${t('install.button')}</button>
      <button class="ib-x" id="ib-x" aria-label="${t('install.close')}">${icon('close')}</button></div>`
  } else {
    // iOS: 共有シート経由の手動手順を案内。
    el.innerHTML = `<div>${t('install.benefit')}<br>
      <span class="muted">${t('install.iosHint', { icon: `<span class="ib-ico">${icon('share')}</span>` })}</span></div>
      <button class="ib-x" id="ib-x" aria-label="${t('install.close')}">${icon('close')}</button>`
  }
  el.addEventListener('click', async (e) => {
    if (e.target.closest('#ib-install')) {
      await promptInstall()
      el.remove()
    } else if (e.target.closest('#ib-x')) {
      localStorage.setItem(INSTALL_DISMISS_KEY, '1')
      el.remove()
    }
  })
  return el
}

// --- 簡易ルータ（ボトムタブ） ---
const TABS = [
  { id: 'library', label: t('nav.library'), ico: 'cloud' },
  { id: 'words', label: t('nav.words'), ico: 'words' },
  { id: 'review', label: t('nav.review'), ico: 'review' },
  { id: 'settings', label: t('nav.settings'), ico: 'settings' },
]

const VIEWS = {
  library: renderLibrary, // 統合ライブラリ（端末＋Drive・フラット）
  words: renderWords,
  review: renderReview,
  settings: renderSettings,
}

const app = document.querySelector('#app')

// ルート解析: '#/play/<hash>' は全画面プレーヤ（タブバー無し）、それ以外はタブ。
function parseRoute() {
  const h = location.hash.replace(/^#\//, '')
  if (h.startsWith('play/')) return { kind: 'play', hash: decodeURIComponent(h.slice(5)) }
  const id = h.split('/')[0]
  return { kind: 'tab', tab: TABS.some((t) => t.id === id) ? id : 'library' }
}

async function render() {
  const r = parseRoute()
  app.innerHTML = `<main class="view" id="view"></main>`
  const view = app.querySelector('#view')
  if (r.kind === 'play') {
    await renderPlayer(view, r.hash)
    return
  }
  app.appendChild(buildTabBar(r.tab))
  try {
    await VIEWS[r.tab](view)
  } catch (e) {
    // ビューが例外で空白になると原因が分からないので、画面にエラーを出す（黙って白画面にしない）。
    console.error('[render]', r.tab, e)
    const box = document.createElement('div')
    box.className = 'card'
    const pre = document.createElement('pre')
    pre.style.cssText = 'white-space:pre-wrap;font-size:12px;color:var(--err);margin:0'
    pre.textContent = `画面の描画でエラー (${r.tab})\n` + String((e && (e.stack || e.message)) || e)
    box.append(pre)
    view.append(box)
  }
  const banner = buildInstallBanner()
  if (banner) view.insertBefore(banner, view.firstChild)
}

function buildTabBar(active) {
  const bar = document.createElement('nav')
  bar.className = 'tabbar'
  bar.innerHTML = TABS.map(
    (t) => `
    <button data-tab="${t.id}" class="${t.id === active ? 'active' : ''}">
      <span class="ico">${icon(t.ico)}</span><span>${t.label}</span>
    </button>`
  ).join('')
  bar.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-tab]')
    if (btn) location.hash = `#/${btn.dataset.tab}`
  })
  return bar
}

window.addEventListener('hashchange', render)

requestPersist()
render()
bgSync() // 起動時に裏で同期（単語/SRS/再生位置をPCと揃える。オフライン/未設定なら黙ってスキップ）
autoUploadAll() // 起動時に未アップの端末項目を Drive へ（連携済＋Wi-Fi設定を満たすときだけ）
